import { EntityStatus } from '@ms/yammer-data-support';
import { CuratedTopicsFilter } from '@ms/yammer-graphql';

import { RequestStatusType, Topic, YammerState } from '../../state/types';
import { getStatus as getRequestStatus } from '../requestStatuses/selectors';

export const maxCuratedTopicsCountToShow = 99;
export const noTopics: Topic['id'][] = [];

type GetTopicsCuratedStatus = (state: YammerState, topicsFilter: CuratedTopicsFilter) => EntityStatus;
export const getTopicsCuratedStatus: GetTopicsCuratedStatus = (state, topicsFilter) =>
  getRequestStatus(state, RequestStatusType.TopicsCuratedLoadRequest, topicsFilter);

type GetLoadMoreTopicsCuratedStatus = (state: YammerState, topicsFilter: CuratedTopicsFilter) => EntityStatus;
export const getLoadMoreTopicsCuratedStatus: GetLoadMoreTopicsCuratedStatus = (state, topicsFilter) =>
  getRequestStatus(state, RequestStatusType.TopicsCuratedLoadMoreRequest, topicsFilter);

type GetTopicsCurated = (state: YammerState, topicsFilter: CuratedTopicsFilter) => Topic['id'][];
export const getTopicsCurated: GetTopicsCurated = (state, topicsFilter) =>
  state.topicsCurated[topicsFilter]?.topicIds ?? noTopics;

type GetTopicsCuratedCount = (state: YammerState, topicsFilter: CuratedTopicsFilter) => number | undefined;
export const getTopicsCuratedCount: GetTopicsCuratedCount = (state, topicsFilter) =>
  state.topicsCurated[topicsFilter]?.topicsCount;

type ShouldLoadMoreTopicsCurated = (state: YammerState, topicsFilter: CuratedTopicsFilter) => boolean;
export const shouldLoadMoreTopicsCurated: ShouldLoadMoreTopicsCurated = (state, topicsFilter) =>
  state.topicsCurated[topicsFilter]?.hasNextPage ?? false;
